import React from 'react'
import Layout from '../../components/Layout/Layout'
import Faqs from '../../components/Faqs/Faqs'

const FAQ = () => {
  return (
    <div>
        <Layout>
            <Faqs/>
        </Layout>
    </div>
  )
}

export default FAQ